
import { SteDeviceViewModelImplemented, } from "./ste.vmi";

export class SteDevKitDeviceViewModelImplemented extends SteDeviceViewModelImplemented {

	public thumbnailImagePath:string = "assets/app/ste/devkit.png";
	public getThumbnailImagePath() : string{
		return this.thumbnailImagePath;
	}

	public static getStaticTitle():string{ // so we can access this w/o an instance i guess
		return super.getStaticTitle() + " DEV-KIT"
	}
	public getTitle():string{ // so we can access this w/o an instance i guess
		return SteDevKitDeviceViewModelImplemented.getStaticTitle();
	}

}